<template>
  <div></div>
</template>

<script>
import { loginConfirm } from "@/api/user.js";
import wx from "weixin-js-sdk";
export default {
  name: "loginConfirm",
  data() {
    return {
      code: "",
      state: "",
    };
  },
  mounted() {
    var that = this;
    this.code = this.$route.query.code;
    this.state = this.$route.query.state;
    this.$dialog.confirm({
      mes: "确认使用微信登录吗?",
      opts: [
        {
          txt: "取消",
          color: false,
          callback: () => {
            wx.closeWindow();
          },
        },
        {
          txt: "确定",
          color: true,
          callback: () => {
            let data = {
              code: that.code,
              state: that.state,
            };
            loginConfirm(data)
              .then((res) => {
                that.$dialog.success("确认成功");
                wx.closeWindow();
              })
              .catch((err) => {
                that.$dialog.error("二维码已失效,请重新扫码");
                setTimeout(function() {
                  wx.closeWindow();
                }, 2000);
              });
          },
        },
      ],
    });
  },
};
</script>
